<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="all">
      <el-form label-width="140px"
               style="margin-top: 5px"
               :rules="rules"
               ref="ruleForm"
               :model="dataForm">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="企业名称"
                          prop="companyName">
              <el-input v-model="dataForm.companyName"
                        placeholder="企业名称"
                        maxlength="50"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码"
                          prop="socialCreditCode">
              <el-input v-model="dataForm.socialCreditCode"
                        maxlength="50"
                        placeholder="统一社会信用代码"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="认证类型"
                          prop="authentTypeCode">
              <el-select v-model="dataForm.authentTypeCode"
                         style="width: 100%"
                         placeholder="请选择">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- todo -->
            <el-form-item label="所属行业">
              <el-select v-model="dataForm.value1"
                         style="width: 30%;float:left"
                         placeholder="大类">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="dataForm.value"
                         style="width: 65%;float:left;margin-left:5%"
                         placeholder="小类">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="企业地址"
                          prop="dizhi">
              <el-select v-model="dataForm.dizhi.provinceId"
                         style="width: 30%;float:left"
                         placeholder="省">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="dataForm.dizhi.cityId"
                         style="width: 30%;float:left;margin-left:5%"
                         placeholder="市">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="dataForm.dizhi.areaId"
                         style="width: 30%;float:left;margin-left:5%"
                         placeholder="区">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <el-input v-model="dataForm.dizhi.address"
                        maxlength="50"
                        placeholder="详细地址：如街道，道路，园区门牌号等"
                        style="width: 100%;margin-top:10px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业法人"
                          prop="legaPerson">
              <el-input v-model="dataForm.legaPerson"
                        placeholder="企业法人"
                        maxlength="50"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="法人身份证"
                          :rules="[
                            { required: true, message: '必填项不能为空'},
                            { type: 'number', message: '身份证须为数字值'}
                          ]"
                          prop="legaIdcard">
              <el-input v-model="dataForm.legaIdcard"
                        placeholder="法人身份证"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照">
              <div class="demo-image__preview">
                <el-image style="width: 200px; height: 130px"
                          :src="url"
                          :preview-src-list="srcList">
                </el-image>
                <el-upload class="upload-demo"
                           :action="action"
                           :with-credentials="true"
                           :headers="myHeaders"
                           :on-change="handleChange"
                           :before-upload="beforeUpload"
                           :file-list="fileList">
                  <el-button size="small"
                             type="primary">点击上传</el-button>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="法人身份证(正面)">
              <el-image style="width: 200px; height: 130px"
                        :src="url"
                        :preview-src-list="srcList">
              </el-image>
              <el-upload class="upload-demo"
                         :action="action"
                         :with-credentials="true"
                         :headers="myHeaders"
                         :on-change="handleChange"
                         :before-upload="beforeUpload"
                         :file-list="fileList">
                <el-button size="small"
                           type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人身份证(反面)">
              <div class="demo-image__preview">
                <el-image style="width: 200px; height: 130px"
                          :src="url"
                          :preview-src-list="srcList">
                </el-image>
                <el-upload class="upload-demo"
                           :action="action"
                           :with-credentials="true"
                           :headers="myHeaders"
                           :on-change="handleChange"
                           :before-upload="beforeUpload"
                           :file-list="fileList">
                  <el-button size="small"
                             type="primary">点击上传</el-button>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer">
        <el-button type="danger"
                   @click="doOverrule">驳回</el-button>
        <el-button type="success"
                   @click="attestation">审核</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  data () {
    var validateAdress = (rule, value, callback) => {
      if (!value.address) {
        callback(new Error('地址能不为空'))
      } else if (!value.address1) {
        callback(new Error('地址能不为空'))
      } else if (!value.address2) {
        callback(new Error('地址能不为空'))
      } else if (!value.address3) {
        callback(new Error('地址能不为空'))
      }
    }
    return {
      dataForm: {
        dizhi: {}
      },
      authentlist: [
        {
          value: '10',
          label: '未认证'
        },
        {
          value: '20',
          label: '待认证'
        },
        {
          value: '30',
          label: '驳回'
        },
        {
          value: '40',
          label: '已认证'
        }
      ],
      options: [
        {
          value: '选项1',
          label: '北京烤鸭'
        },
        {
          value: '选项2',
          label: '北京烤鸭'
        },
        {
          value: '选项3',
          label: '北京烤鸭'
        },
        {
          value: '选项4',
          label: '北京烤鸭'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ],
      fileList: [],
      action: '',
      myHeaders: {},
      rules: {
        companyName: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        // 地址
        dizhi: [
          { required: true, validator: validateAdress, trigger: 'blur' }
        ],
        // 企业法人
        legaPerson: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        // 企业法人身份证
        legaIdcard: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 审合
    attestation () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$confirm('确定要审合通过该用户企业认证申请吗', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: false,
            closeOnPressEscape: false
          }).then(() => {
            this.dataForm.authentFlag = '40'
            this.dataForm.provinceId = this.dataForm.dizhi.provinceId
            this.dataForm.cityId = this.dataForm.dizhi.cityId
            this.dataForm.areaId = this.dataForm.dizhi.areaId
            this.$http.post('/help/user/sys/custCompany/submitAudit', this.dataForm, {
              headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'Authorization': 'Basic cmVucmVuaW86cmVucmVuaW8='
              }
            }).then(({ data: res }) => {
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '审合成功!'
                })
                this.getDateList()
              }
            }).catch(() => { })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消审合'
            })
          })
        } else {
          return false
        }
      })
    },
    // 驳回
    doOverrule () {
      this.$confirm('确定要驳回该用户企业认证申请吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        this.$http.post('/help/user/sys/custCompany/submitAudit', {
          companyId: this.dataForm.companyId,
          authentFlag: '30'
        }, {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic cmVucmVuaW86cmVucmVuaW8='
          }
        }).then(({ data: res }) => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '驳回成功!'
            })
            this.getDateList()
          }
        }).catch(() => { })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消驳回'
        })
      })
    },
    handleChange () {

    },
    beforeUpload () {

    },
    getDateForm () {
      this.$http.get('/help/user/sys/custCompany/delete', {
        params: {
          companyId: this.dataForm.companyId
        }
      }).then(({ data: res }) => {
        this.dataForm = res.data
        this.dataForm.dizhi.provinceId = this.dataForm.provinceId
        this.dataForm.dizhi.cityId = this.dataForm.cityId
        this.dataForm.dizhi.areaId = this.dataForm.areaId
      }).catch(() => { })
    }
  },
  activated () {
    if (this.$route.params.check === 'attestation') {
      this.dataForm.companyId = this.$route.params.id
      this.getDateForm()
    }
  }
}
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 60px;
  margin-top: 10px;
  text-align: center;
}
</style>
<style>
.aui-content > .el-tabs > .el-tabs__content {
  padding: 10px;
}
</style>
